<template>
  <div class="outbox">
    <!-- <el-collapse-transition> -->
    <!-- <transition name="el-zoom-in-top"> -->
    <div class="aboutbg siyuan-extremely-light-text">
      <div class="topline"></div>
      <div class="contentbox">
        <div>
          <p class="title siyuan-extremely-bold-text">關於大倉</p>
          <p class="abouttext">
            2013年，在社會各界和政府相關部門的關注與支持下，北京大學整體回購的“大倉文庫”順利入藏北京大學圖書館。“大倉文庫”是來自日本大倉文化財團的古籍善本專藏，其主體為1912年日本企業家大倉喜八郞購入的我國藏書家董康的誦芬室藏書和譚錫慶的正文齋藏，在大倉集古館完整保存了一百餘年。其藏書內容涵蓋極廣，版本種類齊全。“大倉文庫”的回購，是百年來海外漢籍最大規模的回歸。
          </p>
          <p class="abouttext">
            數字版“大倉文庫”，著力於幫助讀者發現和閱讀源自館藏的珍品一手文獻原貌。不仅梳理這批回歸古籍的版本系統與傳藏情况，更完整收錄文庫全部藏書品種，真實呈現底本原始品貌特徵。讀者可輸入書名和作者名進行文献檢索，也可依照版本類别、四部分類、刊鈔人、國別、刊鈔年代等條件進行文獻篩選，進而瀏覽指定類型的典籍文獻。文獻閱讀支持局部放大圈片，以便看清特定文字、藏印、批校等版本細節。
          </p>
          <p class="abouttext">
            全庫文献總量共計904種，25700餘冊，高清文獻圖片約400萬頁。從國別上來看，包括中國古籍696種、日本古籍207種、朝鮮古籍1種。從內容上來看，涵蓋經、史、子、集四大部類，其中經部96種、史部219種、子部153種、集部388種，又有叢書25種、碑帖23種。從版本形式上來看，含刻本594種、鈔稿本/寫本112種、活字本62種、鈐印本5種、套印本24、拓本12種、鉛印/铜印/石印/影印本等83種，四庫進呈本14種、遞修遞刻本19種、武英殿聚珍本39種，類別全面豐富。
          </p>
        </div>
        <div class="chartcontent">
          <div class="chartbox" id="main"></div>
          <div class="chartbox" id="main2"></div>
        </div>
        <div class="bottomtext siyuan-extremely-light-text">
          <p>
            想了解更多信息，請致電北京大學出版社數字出版中心010-62752035(工作時間8:30-17:00)，郵箱:digital2@pup.cn。
          </p>
        </div>
        <!-- <div class="srolldown">
            <img
              class="tobottom"
              @click="changefix"
              src="/static/newhome/icon/down1.png"
              alt=""
            />
          </div> -->
      </div>
    </div>
    <!-- </transition> -->
    <!-- </el-collapse-transition> -->
    <!-- <el-collapse-transition> -->
    <!-- <transition name="el-zoom-in-top"> -->
    <div class="abouttwobox">
      <div class="abouttwo">
        <div class="centercontent abouttwobg FangZheng-FanTi-Kaiti">
          <div class="titleanimatebox">
            <div class="titleanimate" ref="section">
              <p class="titleone">
                让中华文明同世界各国人民创造的丰富多彩的文明一道，
              </p>
              <p class="titletwo">为人类提供正确的精神指引和强大的精神动力。</p>
            </div>
            <!-- <div class="titleanimate1">
                <p style="text-align: right" class="titlethree">————习近平</p>
              </div> -->
          </div>
        </div>
      </div>
      <div class="abouttwotitle">
        <div class="centercontent">
          <p
            class="title siyuan-extremely-bold-text"
            style="margin: 20px 0 35px"
          >
            功能說明
          </p>
          <div class="function-page">
            <div class="btnbox">
              <!-- 功能按钮栏 -->
              <div class="btn-bar titlebox">
                <!-- 四个切换按钮 -->
                <div
                  v-for="(item, index) in imgList"
                  :key="index"
                  class="function-btn"
                  :class="{ active: currentIndex === index }"
                  @click="switchTab(index)"
                >
                  <div class="roundbox">
                    <div
                      class="roundbg"
                      :style="{
                        'line-height': index == 2 ? '125px' : '120px',
                      }"
                    >
                      <img
                        :style="{ height: index == 2 ? '48px' : '38px' }"
                        class="zoom-effect"
                        :src="'/static/about/title' + (index + 1) + '.png'"
                        alt=""
                      />
                    </div>
                    <div class="roundtextbox">
                      <p class="roundtext siyuan-extremely-light-text">
                        {{ item.btnName }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="line"></div>
            </div>
            <!-- 内容容器：包含箭头 + 图片 -->
            <div class="content-container">
              <!-- 朝上的箭头（衔接按钮栏和内容区） -->
              <!-- <div class="triangle-shadow"></div> -->
              <div
                class="trianglebox"
                :style="{ left: indexToLeft(currentIndex) + '%' }"
              >
                <div class="triangle"></div>
              </div>

              <!-- 图片展示区 -->
              <div class="img-content siyuan-extremely-light-text">
                <p style="margin-bottom: 24px">
                  {{ imgList[currentIndex].imgtitle }}
                </p>
                <div
                  v-for="(citem, cindex) in imgList[currentIndex].imgUrl"
                  :key="cindex"
                  style="margin-bottom: 20px"
                >
                  <img
                    :src="citem.img"
                    :alt="citem.img.title"
                    class="show-img"
                  />
                  <div v-if="citem.title" class="imgtitle">
                    <img src="/static/icon/toparr.png" alt="" />
                    <p>{{ citem.title }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- </el-collapse-transition> -->
    <!-- </transition> -->
  </div>
</template>

<script>
// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
import * as echarts from 'echarts/core'
// 引入柱状图图表，图表后缀都为 Chart
import { BarChart } from 'echarts/charts'
// 引入标题，提示框，直角坐标系，数据集，内置数据转换器组件，组件后缀都为 Component
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent
} from 'echarts/components'
// 标签自动布局、全局过渡动画等特性
import { LabelLayout, UniversalTransition } from 'echarts/features'
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer } from 'echarts/renderers'

// 注册必须的组件
echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  BarChart,
  LabelLayout,
  UniversalTransition,
  CanvasRenderer
])


export default {
  name: "About",
  data () {
    return {
      activeName: 'second',
      visible: false,
      isshow: true,
      title: {
        show1: true,
      },
      currentIndex: 1,
      // 图片列表配置：替换为你的实际图片地址
      imgList: [
        {
          btnName: '注册登録',
          imgtitle: '平臺設置有兩種注册登録方式。手機號登録通過輸入手機號、動態驗證碼，以及獲取的手機短信驗證碼，即可實現注册登録。微信賬户登録，使用微信掃一掃，並綁定手機號，快速實現注册登録。',
          imgUrl: [{ title: '', img: '/static/about/login1.png' }]
        },
        { btnName: '檢索篩選', imgtitle: '平臺設置分類瀏覽，篩選類型有版本類別、四部分類、刊鈔人、國別、刊鈔年代等五個維度，支持單類型篩選和多類型組合篩選。熟悉文獻名和作者的讀者，可以直接輸入書名和作者名進行檢索。', imgUrl: [{ title: '', img: '/static/about/search1.png' }] },
        { btnName: '文獻閲讀', imgtitle: '平臺秉承原貌展現一手文獻的原則，按函套卷冊展示單品文獻，若原文獻有錯裝或缺頁，該頁閱讀框右側會以“注”的形式加以说明。點擊閱讀框左上方的書目詳情，可以了解當前文獻的作者、分類、版本、卷冊數量、主要內容等詳細信息。文獻圖片可以全屏顯示，點擊圖片滑動鼠標滚輪，可局部放大或縮小圖片，看到更多版本細節。', imgUrl: [{ title: '閲讀頁面', img: '/static/about/wenxian11.png' }, { title: '詳情頁面', img: '/static/about/wenxian22.png' }, { title: '全屏頁面', img: '/static/about/wenxian33.png' }] },
        { btnName: '個人中心', imgtitle: '平臺為讀者設置了個人中心，所有讀者閲讀和收藏過的文獻都會列在這裡，便於讀者隨時恢復從前的閲讀行為或者迅速定位到感興趣的文獻。', imgUrl: [{ title: '', img: '/static/about/user.png' }] },
      ],
      option1: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            // itemStyle: {
            //   shadowBlur: 20, // 阴影的模糊大小
            //   shadowColor: 'rgba(0, 0, 0, 0.5)' // 阴影颜色
            // }
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          // containLabel: true
          outerBounds: {
            left: true,
            right: true,
            top: true,
            bottom: true
          },
        },
        xAxis: [
          {
            type: 'category',
            data: ['中國古籍', '日本古籍', '朝鮮古籍'],
            axisTick: {
              alignWithLabel: true
            }
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            //name: 'Direct',
            type: 'bar',
            barWidth: '60%',
            data: [696, 207, 1],
            barWidth: 18,
            barMaxWidth: 18,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#992f25' },
                { offset: 0.7, color: '#992f25' },
                { offset: 1, color: '#fff' }
              ])
            },
            emphasis: {
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#992f25' },
                  { offset: 0.7, color: '#992f25' },
                  { offset: 1, color: '#fff' }
                ])
              }
            },
          }
        ]
      },
      option2: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          // containLabel: true
          outerBounds: {
            left: true,
            right: true,
            top: true,
            bottom: true
          },
        },
        xAxis: [
          {
            type: 'category',
            data: ['經部', '史部', '子部', '集部', '叢書', '碑帖'],
            axisTick: {
              alignWithLabel: true
            }
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            // name: 'Direct',
            type: 'bar',
            barWidth: '60%',
            data: [96, 219, 153, 388, 25, 23],
            barWidth: 18,
            barMaxWidth: 18,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#d7cfb3' },
                { offset: 0.7, color: '#d7cfb3' },
                { offset: 1, color: '#fff' }
              ])
            },
            emphasis: {
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#d7cfb3' },
                  { offset: 0.7, color: '#d7cfb3' },
                  { offset: 1, color: '#fff' }
                ])
              }
            },
          }
        ]
      }

    }
  },
  props: {
    isfix: false,

  },
  mounted () {
    // 接下来的使用就跟之前一样，初始化图表，设置配置项
    var myChart = echarts.init(document.getElementById('main'))
    myChart.setOption(this.option1)
    var myChart2 = echarts.init(document.getElementById('main2'))
    myChart2.setOption(this.option2)
    window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll () {
      // this.sections.forEach(section => {
      const el = this.$refs.section
      // console.log(el.getBoundingClientRect().top, 'el')
      if (el.getBoundingClientRect().top < window.innerHeight && el.getBoundingClientRect().bottom > 0) {

        el.classList.add('newanimate')
      } else {
        el.classList.remove('newanimate')
      }

    },
    changefix () {
      this.isshow = !this.isshow
    },
    changeShow (e) {
      // if (e.wheelDelta || e.detail) {
      //   if (e.wheelDelta < 0 || e.detail > 0) {     //当鼠标滚轮向下滚动时
      //     this.isshow = false
      //   }
      // }
      var scrollPosition = window.innerHeight + window.pageYOffset
      var totalHeight = document.body.offsetHeight

      if (scrollPosition >= totalHeight) {
        // console.log('已滚动到底部')
        this.isshow = false
        setTimeout(() => {
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth' // 平滑滚动效果
          })
        }, 100) // 1000毫秒后，即1秒后执行

      }
    },
    changeShow2 (e) {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      const isAtTop = Math.abs(scrollTop) < 1 // 容错：避免精度问题
      if (e.wheelDelta || e.detail) {
        if (e.wheelDelta > 0 || e.detail < 0) {     //当鼠标滚轮向上滚动时
          if (isAtTop && e.deltaY < 0) {
            this.isshow = true
          }
          // console.log(e, 'eee')
        }
      }

    },
    handleClick (tab, event) {
      console.log(tab, event)
    },
    switchTab (index) {
      this.currentIndex = index
    },
    // 计算箭头left位置
    indexToLeft (index) {
      // 四个按钮均分宽度，箭头居中 + translateX(-50%) 微调
      //return 25 * index + 12.5
      if (index == 0) {
        return 0.5
      } else if (index == 1) {
        return 31.3
      } else if (index == 2) {
        return 62
      } else {
        return 92.5
      }
      return 25 * index + 12.5
    }

  }


}
</script>

<style lang="less" scoped>
//@import url(../../pages/newcommon.css);
.outbox {
  overflow: hidden;
  .topline {
    width: 100%;
    height: 5px;
    background-color: #f5f5f5;
  }
  // overflow: hidden;
}
// .outbox::-webkit-scrollbar {
//   display: none; /* 直接隐藏滚动条 */
// }

/* 页面整体样式 */
.function-page {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
}

/* 按钮栏：横向分布，无底部边框 */
.btn-bar {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0; /* 取消间距，让箭头紧贴按钮栏 */
}

/* 功能按钮样式 */
.function-btn {
  cursor: pointer;
  // color: #666;
  color: #494949;
  font-size: 16px;
  padding: 10px 0;
  //width: 25%; /* 四个按钮均分宽度 */
  text-align: center;
  transition: color 0.3s ease;
}

/* 按钮选中态 */
.function-btn.active {
  // color: rgb(170, 29, 31);
  color: #a97c47;
  font-weight: 600;
}

/* 内容容器：相对定位，包裹箭头和图片 */
.content-container {
  position: relative;
  margin-top: 0;
  // border: 1px solid #e5e7eb;
  //border-radius: 8px;
  background: #fff;
  box-shadow: 0 0 15px 10px rgba(0, 0, 0, 0.15);
}

/* 箭头指示器：朝上，紧贴按钮栏，衔接内容区 */
.arrow-indicator {
  position: absolute;
  top: -21px; /* 箭头一半在内容区外，一半在内，实现衔接 */
  width: 42px;
  height: 42px;

  background: #fff; /* 箭头背景与内容区一致 */
  // border: 1px solid #e5e7eb; /* 箭头加边框，与内容区边框匹配 */
  // border-bottom: none;
  // border-right: none;
  clip-path: polygon(0 0, 0 100%, 100% 100%); /* 朝上的三角形 */
  transition: left 0.3s ease-in-out; /* 切换动画 */
  transform: translateX(-50%) rotate(135deg); /* 旋转+居中，实现尖角效果 */
  z-index: 10; /* 箭头层级高于内容区，避免被遮挡 */
  // box-shadow: 0 0 15px 10px rgba(0, 0, 0, 0.15);
  /* 深色背景下的阴影（如果内容区不是白色） */
  filter: drop-shadow(20px 20px 20px rgba(0, 0, 0, 0.3));
}
.trianglebox {
  position: absolute;
  top: -41px;
  height: 42px;
  width: 88px;
  /* border: 1px solid; */
  overflow: hidden;
  // overflow: hidden;
  transition: left 0.3s ease-in-out;
}
.triangle {
  margin-top: 22px;
  margin-left: 20px;
  /* 箭头一半在内容区外，一半在内，实现衔接 */
  width: 42px;
  height: 42px;

  border: none;
  background: #fff;
  box-shadow: 0 0 15px 5px rgba(0, 0, 0, 0.15);
  transform: rotate(45deg);
  border-radius: 5px 0px 0px 0px;

  // z-index: -1;
}

/* 图片展示区 */
.img-content {
  color: #545454;
  width: 100%;
  text-align: justify;
  // display: flex;
  // justify-content: center;
  // align-items: center;
  // min-height: 500px;
  padding: 26px 45px 1px;
  box-sizing: border-box;
  margin: 30px 0 50px;
  border-radius: 8px;

  img {
    width: 100%;
  }
  p {
    font-size: 18px;
    line-height: 1.5;
    // margin-bottom: 24px;
  }
  .imgtitle {
    display: flex;
    align-items: baseline;
    img {
      height: 10px;
      width: auto;
      margin-right: 5px;
    }
    p {
      font-size: 14px;
    }
  }
}

/* 展示图片样式 */
.show-img {
  max-width: 100%;
  // max-height: 480px;
  object-fit: contain; /* 保持图片比例，不拉伸 */
  border-radius: 4px;
}

/* 移动端适配 */
// @media (max-width: 768px) {
//   .function-btn .btn-text {
//     font-size: 14px;
//   }
//   .img-content {
//     min-height: 300px;
//     padding: 10px;
//   }
//   .show-img {
//     max-height: 280px;
//   }
//   .arrow-indicator {
//     width: 12px;
//     height: 12px;
//     top: -6px;
//   }
// }
.aboutbg {
  color: #434343;
  letter-spacing: 1px;
  text-align: justify;
  background-color: #fefefe;
  background-image: url("/static/newhome/aboutbg.png");
  // background-size: cover;
  background-repeat: no-repeat; /* 不重复背景图片 */
  background-position: center bottom; /* 背景图片居中底部 */
  background-size: 100% 100%; /* 宽度100%，高度自动 */
  height: calc(~"100vh - 2rem - 50px");
  // height: calc(~"100vh - 2rem - 30px");
  // height: 90vh;
}
.contentbox {
  width: 1200px;
  height: 100%;
  // height: calc(~"100vh - 2rem - 50px");
  // display: flex;
  // flex-direction: column;
  // align-items: center;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  justify-content: center;
}
.title {
  margin-bottom: 20px;
  line-height: 1.5;
  font-size: 24px;
  font-weight: 700;
  color: #2d2d2d;

  // margin-bottom: 40px;
}
.abouttext {
  font-size: 18px;
  margin: 20px 0;
  line-height: 1.5;
  // font-weight: 600;
  color: #545454;
}
.abouttext::last-child {
  margin-bottom: 0;
}
.chartcontent {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  // height: 38.3%;
}
.chartbox {
  width: 555px;
  height: 325px;
  border: 1px solid #d9d9d9;
  background-color: #fff;
}
.bottomtext {
  // height: 14.5%;
  color: #545454;
  margin-top: 20px;
  font-size: 20px;
  text-align: center;
  line-height: 2;
  font-weight: 600;
}
.srolldown {
  width: 100%;
  height: 70px;
  text-align: center;
  // margin-bottom: 0;
  position: absolute;
  left: 0;
  bottom: 40px;

  img {
    width: 27px;
    height: 48px;
    // position: absolute;
    // left: 49.85%;
    // bottom: 0;
    // position: absolute;
    cursor: pointer;
    // .tobottom {
    animation: mymovetwo 2s ease-in-out infinite;
    // }
  }
}

@keyframes mymovetwo {
  0% {
    transform: translate(0, -10px);
    opacity: 1;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: translate(0, 10px);
    opacity: 1;
  }
}
.abouttwobox {
  width: 100%;
  // height: calc(~"100vh - 2rem - 50px");
  // overflow-y: scroll;
  .abouttwo {
    width: 100%;
    height: 200px;
    background-image: url("/static/newhome/aboutbgtwo.png");
    background-repeat: no-repeat; /* 不重复背景图片 */
    background-position: center bottom; /* 背景图片居中底部 */
    background-size: 100% 100%; /* 宽度100%，高度自动 */

    .abouttwobg {
      padding-top: 110px;
      p {
        color: #fff;
        font-size: 21px;
        //line-height: 1.5;
        font-weight: 550;
        font-style: normal;
        // letter-spacing: 1px;
        //font-family: "FangZheng-FanTi-Kaiti", serif;
      }
    }
  }
  .titlebox {
    // display: flex;
    // justify-content: space-between;
    // align-items: center;

    .roundbg {
      width: 96px;
      height: 96px;
      border-radius: 50%;
      background-color: #e6e6e6;
      text-align: center;
      line-height: 120px;

      img {
        height: 38px;
        width: auto;
      }
    }
    .roundtextbox {
      width: 100%;
    }
    .roundtext {
      // display: inline-block;
      font-size: 18px;
      text-align: center;
      line-height: 1.5;
      // color: #494949;
      font-weight: 600;
    }
  }
}

.centercontent {
  width: 1200px;
  margin: 0 auto;
}
.zoom-effect {
  transition: transform 0.3s ease; /* 平滑过渡效果 */
}

.zoom-effect:hover {
  transform: scale(1.1); /* 放大到110% */
}
.btnbox {
  position: relative;
}

.line {
  width: 100%;
  height: 1;
  border-bottom: 1.5px dashed #e6e6e6;
  position: absolute;
  top: 56px;
  z-index: -999;
}

@keyframes siz {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}
@keyframes go {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}
@keyframes off {
  50% {
    border-right: 3px solid;
  }
}
.titleanimatebox {
  // display: flex;
  // justify-content: space-between;
  // align-items: end;
}
.titleanimate {
  width: 550px;
  line-height: 1.5;

  .titleone {
    overflow: hidden;
    height: 24px;
    border-color: transparent;
  }
  .titletwo {
    overflow: hidden;
    height: 24px;
    // border-right: 3px solid transparent;
    // animation: go 3s steps(21) 3s backwards,
    //   off 0.5s 3s step-end 6 alternate backwards;
  }
}
.newanimate {
  .titleone {
    animation: go 3s steps(25), off 0.5s both step-end 6;
    animation-fill-mode: backwards;
  }
  .titletwo {
    border-right: 3px solid transparent;
    animation: go 3s steps(21) 3s backwards,
      off 0.5s 3s step-end 6 alternate backwards;
  }
}

.titleanimate1 {
  width: 152px;
  text-align: right;
  .titlethree {
    // width: 0;
    // border-color: transparent;
    overflow: hidden;
    height: 24px;
    border-right: 3px solid transparent;
    animation: go 1s steps(7) 3s backwards,
      off 0.5s 6s step-end 6 alternate backwards;
    animation-delay: 6s;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/about/index.vue